import clsx from 'clsx';
import colorMapBotonBrillante from '../../../utils/colorMapBotonBrillante';
import styles from './BotonChico04PdfPago.module.css';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfDetallesPago from '../../PdfDetallesPago/PdfDetallesPago.jsx';
import axiosInstance from '../../../services/AxiosInstance';
import { useEffect, useState } from 'react';

const BotonChico04PdfPago = ({ texto, bgColor, idMovimientoSaldo }) => {
  const [detallesPago, setDetallesPago] = useState([]);

  let colorElegido =
    colorMapBotonBrillante[bgColor] || colorMapBotonBrillante['blue'];

  useEffect(() => {
    const fetchDetallesPago = async () => {
      try {
        const response = await axiosInstance.post('/api/payment/getPaymentById', {
          idMovimientoSaldo,
        });

        setDetallesPago(response.data);
      } catch (error) {
        // Error silencioso
      }
    };
    fetchDetallesPago();
  }, []);

  return (
    <div className="bg-bgContenedorOscuro rounded-lg">
      <PDFDownloadLink
        document={<PdfDetallesPago detallesPago={detallesPago} />}
        fileName={`Casino Print - Pago ${detallesPago.id}.pdf`}
      >
        <button
          className={clsx(
            styles[`${bgColor}-shine-background`],
            'text-gray-300 text-sm',
            'px-3 py-3 font-bold rounded-lg border-4 transition pixel-button w-fit hover:text-yellow-50',
            colorElegido.bg,
            colorElegido.border,
            colorElegido.hoverBg,
            colorElegido.hoverBorder,
            colorElegido.hoverShadow
          )}
        >
          <span>{texto}</span>
        </button>
      </PDFDownloadLink>
    </div>
  );
};

export default BotonChico04PdfPago;
